module.exports = __webpack_public_path__ + "images/edf75451b5b4a05088bd2048bb888820.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/wine-hover.jpg
// module id = 717
// module chunks = 1 2